export type Language = 'en' | 'bn';

export const translations = {
  en: {
    brandName: 'Verve',
    tagline: 'Free, Seamless, Privacy-First Video Conferencing',
    heroTitlePrefix: 'Seamless Video Calls,',
    heroTitleHighlight: 'Zero Friction. Zero Accounts.',
    heroSubtitle: 'Instant, encrypted meetings directly in your browser. Zero accounts, zero tracking, zero subscription fees.',
    createMeeting: 'Create Meeting',
    joinMeeting: 'Join Meeting',
    enterCode: 'Enter Meeting ID',
    enterMeetingUrlOrId: 'e.g. vrv-a4x7-9m2k or meeting URL',
    meetingTitle: 'Meeting Title (Optional)',
    passcodeOptional: 'Passcode (Optional)',
    meetingPasscode: 'Meeting Passcode',
    passcodePlaceholder: 'Optional 4-8 character code',
    enableWaitingRoom: 'Enable Waiting Room',
    instantMeeting: 'Start Instant Meeting',
    creatingMeeting: 'Creating Meeting...',
    displayName: 'Your Display Name',
    readyToJoin: 'Ready to join?',
    enterMeeting: 'Enter Meeting',
    joining: 'Joining...',
    backToHome: 'Back to Home',
    mute: 'Mute',
    unmute: 'Unmute',
    videoOn: 'Start Video',
    videoOff: 'Stop Video',
    shareScreen: 'Share Screen',
    stopSharing: 'Stop Sharing',
    participants: 'Participants',
    chat: 'Chat',
    polls: 'Polls',
    settings: 'Settings',
    leave: 'Leave Call',
    endForEveryone: 'End Call for All',
    raiseHand: 'Raise Hand',
    lowerHand: 'Lower Hand',
    waitingRoomTitle: "You're in the waiting room",
    waitingRoomDesc: 'The host will let you in shortly. Your camera and microphone are ready.',
    copyLink: 'Copy Link',
    linkCopied: 'Meeting link copied to clipboard!',
    noAccountNeeded: 'No registration. 100% Free Forever • Powered by Solveran',
    admit: 'Admit',
    reject: 'Reject',
    kick: 'Remove',
    forceMute: 'Mute',
    typeMessage: 'Type a message...',
    send: 'Send',
    createPoll: 'Create Poll',
    pollQuestion: 'Poll Question',
    option: 'Option',
    vote: 'Vote',
    closePoll: 'Close Poll',
    activeSpeaker: 'Speaking',
    cameraBlocked: 'Camera access was denied. Please allow permissions in browser settings.',
    micBlocked: 'Microphone access was denied. Please allow permissions in browser settings.',
    profilePicture: 'Participant Profile Picture',
    avatarOptional: 'Optional Picture (Default)',
    avatarRequired: 'Required Picture (Must upload photo)',
    avatarDisabled: 'Disabled (Initials only)',
    uploadPhoto: 'Upload Photo',
    snapCamera: 'Snap Camera',
    removePhoto: 'Remove',
    cameraDefault: 'Camera (Default)',
    micDefault: 'Microphone (Default)',
    featurePrivateTitle: 'Anonymous & Private',
    featurePrivateDesc: 'No passwords, emails, or logins. Cryptographically signed capability tokens isolate every session.',
    featureEngineTitle: 'Solveran Ultra-Scale Media Engine',
    featureEngineDesc: 'Proprietary real-time media routing engineered by Solveran delivers crystal-clear 1080p video with near-zero latency worldwide.',
    featureFreeTitle: 'Zero Cost, Zero Tiers',
    featureFreeDesc: 'Every feature is unlocked for everyone. Full HD video, unlimited duration, screen sharing, and live polls.',
    meetingCreated: 'Meeting Created!',
    shareLinkNoAccounts: 'Share this link with your participants. No accounts needed.',
    audioBlockedNotice: '🔇 Audio playback blocked by browser. Click anywhere to listen.',
    endToEndEncrypted: 'End-to-end encrypted session',
  },
  bn: {
    brandName: 'ভার্ভ (Verve)',
    tagline: 'সম্পূর্ণ বিনামূল্যে, বাধাহীন এবং নিরাপদ ভিডিও মিটিং',
    heroTitlePrefix: 'নিরবচ্ছিন্ন ভিডিও মিটিং,',
    heroTitleHighlight: 'কোনো একাউন্ট বা ঝামেলা ছাড়া।',
    heroSubtitle: 'সরাসরি ব্রাউজারে ইনস্ট্যান্ট এনক্রিপ্টেড মিটিং। কোনো অ্যাকাউন্ট, ট্র্যাকিং বা সাবস্ক্রিপশন ফি নেই।',
    createMeeting: 'মিটিং তৈরি করুন',
    joinMeeting: 'মিটিংয়ে যোগ দিন',
    enterCode: 'মিটিং আইডি লিখুন',
    enterMeetingUrlOrId: 'যেমন: vrv-a4x7-9m2k অথবা মিটিং লিংক',
    meetingTitle: 'মিটিংয়ের নাম (ঐচ্ছিক)',
    passcodeOptional: 'পাসকোড (ঐচ্ছিক)',
    meetingPasscode: 'মিটিং পাসকোড',
    passcodePlaceholder: 'ঐচ্ছিক ৪-৮ অক্ষরের পাসকোড',
    enableWaitingRoom: 'ওয়েটিং রুম চালু করুন',
    instantMeeting: 'তাত্ক্ষণিক মিটিং শুরু করুন',
    creatingMeeting: 'মিটিং তৈরি হচ্ছে...',
    displayName: 'আপনার নাম',
    readyToJoin: 'যোগ দিতে প্রস্তুত?',
    enterMeeting: 'মিটিংয়ে প্রবেশ করুন',
    joining: 'যুক্ত হচ্ছে...',
    backToHome: 'হোম পেজে ফিরুন',
    mute: 'মাইক বন্ধ',
    unmute: 'মাইক চালু',
    videoOn: 'ভিডিও চালু',
    videoOff: 'ভিডিও বন্ধ',
    shareScreen: 'স্ক্রিন শেয়ার',
    stopSharing: 'শেয়ার বন্ধ করুন',
    participants: 'অংশগ্রহণকারী',
    chat: 'বার্তা/চ্যাট',
    polls: 'পোল/ভোট',
    settings: 'সেটিংস',
    leave: 'মিটিং ত্যাগ করুন',
    endForEveryone: 'সবার জন্য মিটিং শেষ',
    raiseHand: 'হাত তুলুন',
    lowerHand: 'হাত নামান',
    waitingRoomTitle: 'আপনি ওয়েটিং রুমে আছেন',
    waitingRoomDesc: 'হোস্ট শীঘ্রই আপনাকে যুক্ত করবেন। আপনার ক্যামেরা ও মাইক প্রস্তুত রয়েছে।',
    copyLink: 'লিংক কপি',
    linkCopied: 'মিটিং লিংক ক্লিপবোর্ডে কপি করা হয়েছে!',
    noAccountNeeded: 'কোন অ্যাকাউন্টের প্রয়োজন নেই। আজীবন সম্পূর্ণ ফ্রি • Powered by Solveran',
    admit: 'অনুমতি দিন',
    reject: 'বাতিল করুন',
    kick: 'বের করুন',
    forceMute: 'মাইক বন্ধ করুন',
    typeMessage: 'একটি বার্তা লিখুন...',
    send: 'পাঠান',
    createPoll: 'নতুন পোল তৈরি করুন',
    pollQuestion: 'পোলের প্রশ্ন',
    option: 'বিকল্প',
    vote: 'ভোট দিন',
    closePoll: 'পোল বন্ধ করুন',
    activeSpeaker: 'কথা বলছেন',
    cameraBlocked: 'ক্যামেরা ব্যবহারের অনুমতি দেওয়া হয়নি। ব্রাউজার সেটিংসে অনুমতি দিন।',
    micBlocked: 'মাইক্রোফোন ব্যবহারের অনুমতি দেওয়া হয়নি। ব্রাউজার সেটিংসে অনুমতি দিন।',
    profilePicture: 'প্রোফাইল ছবি নীতি',
    avatarOptional: 'ঐচ্ছিক ছবি (ডিফল্ট)',
    avatarRequired: 'বাধ্যতামূলক ছবি (ছবি আপলোড আবশ্যক)',
    avatarDisabled: 'বন্ধ (শুধুমাত্র নামের আদ্যক্ষর)',
    uploadPhoto: 'ছবি আপলোড',
    snapCamera: 'ক্যামেরা স্ন্যাপ',
    removePhoto: 'মুছুন',
    cameraDefault: 'ক্যামেরা (ডিফল্ট)',
    micDefault: 'মাইক্রোফোন (ডিফল্ট)',
    featurePrivateTitle: 'বেনামী ও সম্পূর্ণ ব্যক্তিগত',
    featurePrivateDesc: 'কোন পাসওয়ার্ড বা ইমেল নেই। ক্রিপ্টোগ্রাফিক টোকেনের মাধ্যমে প্রতিটি সেশন সুরক্ষিত।',
    featureEngineTitle: 'সলভারান আল্ট্রা-স্কেল মিডিয়া ইঞ্জিন',
    featureEngineDesc: 'সলভারানের তৈরি রিয়েল-টাইম মিডিয়া রাউটিং ১০৮০p স্পষ্ট ভিডিও ও বিশ্বব্যাপী সর্বনিম্ন ল্যাটেন্সি নিশ্চিত করে।',
    featureFreeTitle: 'কোনো খরচ নেই, কোনো টিয়ার নেই',
    featureFreeDesc: 'সবার জন্য সব সুবিধা উন্মুক্ত। ফুল এইচডি ভিডিও, সীমাহীন সময়, স্ক্রিন শেয়ার এবং লাইভ পোল।',
    meetingCreated: 'মিটিং তৈরি সম্পন্ন!',
    shareLinkNoAccounts: 'অংশগ্রহণকারীদের সাথে এই লিংক শেয়ার করুন। কোনো অ্যাকাউন্টের প্রয়োজন নেই।',
    audioBlockedNotice: '🔇 ব্রাউজারের কারণে সাউন্ড বন্ধ আছে। শুনতে যেকোনো জায়গায় ক্লিক করুন।',
    endToEndEncrypted: 'এন্ড-টু-এন্ড এনক্রিপ্টেড মিটিং',
  },
};

let currentLang: Language = 'en';

export function getLanguage(): Language {
  return currentLang;
}

export function setLanguage(lang: Language) {
  currentLang = lang;
}

export function t(key: keyof typeof translations['en']): string {
  return translations[currentLang][key] || translations['en'][key] || key;
}
